import { render } from "./VUEColorPicker.vue?vue&type=template&id=438d7e49"
import script from "./VUEColorPicker.vue?vue&type=script&lang=js"
export * from "./VUEColorPicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__